import React from 'react';

import { isEmpty } from 'lodash';
import { InvitationBlockData, TableParamsType } from '../../../types/common';
import { Button } from '@packages/ui/primitives/Button';
import { Typography } from '@packages/ui/primitives/Typography';
import { DataTable } from '@packages/ui/patterns/DataTable';

const InvitationBlock = DataTable.BulkActionBar;

interface TableInvitationBlockProps {
  inivitationBlockDatas?: InvitationBlockData;
  checkedValues: string[];
  showPublishAward?: boolean;
  showSendEmail?: boolean;
  showEarnMultiplier?: boolean;
  handlePublishAward?: any;
  handleSendEmail?: any;
  handleBulkExport?: any;
  handleEarnMultiplier?: any;
  filter: TableParamsType;
  totalCounts?: number;
  isSelectAllActive?: boolean;
  useSelectAllForCount?: boolean;
}

const renderInvitationBlock = (
  data: InvitationBlockData,
  checkedValues: string[],
  totalCounts?: number,
  isSelectAllActive?: boolean,
  useSelectAllForCount?: boolean
) => {
  // Show totalCounts when "Select All" checkbox was clicked and useSelectAllForCount is true
  const displayCount =
    useSelectAllForCount !== false && isSelectAllActive && totalCounts
      ? totalCounts
      : checkedValues.length;

  return (
    <InvitationBlock>
      {data.buttons.map((button, index) => (
        <Button
          key={`invitation-button-${index}`}
          variant={button.variant === 'secondary-outline' ? 'secondary' : (button.variant as any) || 'secondary'}
          size='sm'
          label={button.title}
          onClick={button.handleAction}
          style={{
            ...(button.fontColor ? { color: button.fontColor } : {}),
            ...(button.borderColor ? { borderColor: button.borderColor } : {}),
          }}
        />
      ))}

      {data.heading?.showHeading && (
        <Typography variant='body-xs'>
          {`${String(displayCount ?? '')} ${data.heading.title}${
            displayCount > 1 ? 's' : ''
          } Selected`}
        </Typography>
      )}
    </InvitationBlock>
  );
};

const TableInvitationBlock = (props: TableInvitationBlockProps) => {
  const {
    inivitationBlockDatas,
    checkedValues,
    showPublishAward,
    showSendEmail,
    showEarnMultiplier,
    handlePublishAward,
    handleSendEmail,
    handleEarnMultiplier,
    handleBulkExport,
    filter,
    totalCounts,
    isSelectAllActive,
    useSelectAllForCount = true, // Default to true for backward compatibility
  } = props;

  return (
    <>
      {!isEmpty(checkedValues) &&
        inivitationBlockDatas &&
        renderInvitationBlock(
          inivitationBlockDatas,
          checkedValues,
          totalCounts,
          isSelectAllActive,
          useSelectAllForCount
        )}
    </>
  );
};

export default TableInvitationBlock;
